import { Component, ElementRef, Input, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { NgbTimeStruct, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { MeasureService } from 'app/measure.service';
import { IIntervallo, Intervallo } from 'app/model/ambulatorio';
import { Impostazioni } from 'app/model/impostazioni_agenda';
import { GiornoScT } from 'app/model/time';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { debounceTime, map, take } from 'rxjs/operators';
import { generateAuthForScT } from '../../../utils';
import { Config } from '../../config.const';
import { Agenda } from '../../model/agenda';
import { HttpParams } from '@angular/common/http';

interface IUpdateRequest {
	intervallo: Intervallo,
	value: IIntervallo
}

@Component({
	selector: 'app-ambulatorio-sct',
	templateUrl: './ambulatorio-sct.html',
	styleUrls: ['./ambulatorio-sct.css']
})
export class AmbulatorioSctComponent implements OnDestroy {

	private readonly aggiorna: (inizio: NgbTimeStruct, fine: NgbTimeStruct, nome: string) => void;
	private readonly subscription: Subscription;
	mobileView: boolean;

	constructor(
		measureService: MeasureService
	) {
		const updateQueue = new Subject<IUpdateRequest>();

		this.aggiorna = (inizio: NgbTimeStruct, fine: NgbTimeStruct, nome: string) => {
			const interval = { inizio: inizio, fine: fine, ambulatorio: nome };
			this.correct = this.validHours(interval);
			if (this.correct) {
				updateQueue.next({
					intervallo: this.intervalloSelezionato,
					value: interval
				});
			}
		};

		this.subscription = updateQueue.pipe(
			debounceTime(300),
		).subscribe(async update => {

			debugger

			if (update.intervallo.id === 0) {
				return
			}

			let data = update.value
			// estraggo la durata e la mando al backend
			if (this.generali.intervallo && this.generali.intervallo.minute) {
				data['durata'] = this.generali.intervallo.minute
			}

			const __data = generateAuthForScT(this.agenda.codice_fiscale)

			const url = `${Config.baseURLScT}/agende/${this.agenda.codice_fiscale}/${this.agenda.nome}/impostazioni/ambulatorio/${update.intervallo.giorno}/${update.intervallo.id}?__data=${__data}`
			const request = await fetch(url, {
				method: 'POST',
				body: JSON.stringify(data),
				credentials: 'include',
				headers: {
					'content-type': 'application/json'
				}
			})
			const response = await request.text()

			// devo settare il parametro __data per l'update
			//const httpParams: HttpParams = new HttpParams()
			//httpParams.set('__data', __data as string)
			update.intervallo.update(update.value/*, { params: httpParams }*/)
		});

		this.mobileView = measureService.isMobile();
	}

	// BAU!
	//       __
	//  (___()'`;
	//  /,    /`
	//  \\"--\\
	@ViewChildren(NgbTimepicker, { read: ElementRef })
	set picker(value: QueryList<ElementRef>) {
		// Diciamo grazie ai tizi di bootstrap.
		for (let el of value.map(c => c.nativeElement as HTMLElement)) {
			let list = el.querySelectorAll(".btn-link");
			for (var i = 0; i < list.length; i++) {
				(list.item(i) as HTMLElement).tabIndex = -1;
			}
		}
	}

	@Input()
	generali: Impostazioni;

	private _ambulatorio: GiornoScT[];
	@Input()
	agenda: Agenda

	@Input()
	set ambulatorio(value: GiornoScT[]) {
		this._ambulatorio = value;
		this.peek = Observable.combineLatest(value).pipe(
			map(() => true),
			take(1)
		).toPromise();
	}

	get ambulatorio(): GiornoScT[] {
		return this._ambulatorio;
	}

	peek: Promise<boolean>;

	giorni = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

	correct = true;
	intervalloSelezionato: Intervallo;
	giorno: GiornoScT;

	select(giorno: GiornoScT, intervallo: Intervallo) {
		this.intervalloSelezionato = intervallo;
		this.giorno = giorno;
		intervallo.subscribe(slot => {
			if (slot.fine.hour === 0 && slot.fine.minute === 0) {
				slot.inizio.hour = this.generali.inizio_giornata.hour;
				slot.inizio.minute = this.generali.inizio_giornata.minute;
				slot.fine.hour = this.generali.fine_giornata.hour;
				slot.fine.minute = this.generali.fine_giornata.minute;
			}
		});
	}

	hide() {
		this.intervalloSelezionato = null;
		this.giorno = null;
	}

	delete(intervallo: Intervallo) {
		if (!intervallo.id) {
			intervallo.id = this.intervalloSelezionato.id
		}
		this.giorno.delete(intervallo);
		this.hide();
	}


	validHours(intervallo: IIntervallo) {
		return (intervallo.inizio.hour < intervallo.fine.hour) ||
			(
				(intervallo.inizio.hour === intervallo.fine.hour) &&
				(intervallo.inizio.minute < intervallo.fine.minute)
			);
	}

	check(intervallo: IIntervallo) {
		return this.validHours(intervallo);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/app/impostazioni_agenda/ambulatorio-sct/ambulatorio-sct.ts